import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ApiService } from './shared/services/api.service';
import { AuthenticationService } from './modules/auth/services/authentication.service';
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [CommonModule, RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {
  constructor(
    public apiService: ApiService,
    public authService: AuthenticationService,
  ) {
    this.getLicense()
  }

  getLicense() {
    this.apiService.license = JSON.parse(localStorage.getItem('license') || '{}')
    this.apiService.getAllWithParams('license/', {}, false)
      .subscribe({
        next: (data: any) => {
          localStorage.setItem('license', JSON.stringify(data))
          this.apiService.license = data
        },
      });
  }
}
